import { type P, type E, arr, get, n, s, values, call, truthy } from './support-b2';
import { strtoupper } from '../../php-compat';
const layer='triggers_when_enemy_within_ft_reduced_to_zero_vitality';
/** PHP: ft_zero_vitality_witness_entry_ft (includes/functions/janus/encounter/zero_vitality_witness_triggers.php:90) */
export function ftZeroVitalityWitnessEntryFt(entry: P, root: P, env: E): P {
    let ability:P;
    if(arr(entry)) {
        entry=call(env,'ft_entry_restore_item_arr',{entry});ability=get(entry,'item_arr');
        if(!arr(ability) && !(typeof ability==='string' && call(env,'check_uuid',{uuid:ability}))) ability=truthy(call(env,'item_field',{item_arr:entry,key:'item_id'})) ? entry : null;
        if(ability===null) return 0;
    } else if(typeof entry==='string' && call(env,'check_uuid',{uuid:entry})) ability=entry;
    else return 0;
    if(call(env,'ft_layer_entry_needs_resolve',{v:ability})) {
        const uuid=strtoupper(s(call(env,'layer_list_entry_uuid',{entry:ability})));
        if(uuid==='' || !call(env,'check_uuid',{uuid})) return null;
        ability=call(env,'ft_catalog_def',{root,uuid}) ?? call(env,'query_full_item_arr',{item_id:uuid,debug_variable_name: 'ft_zero_vitality_witness_entry_ft',suppress_missing_item_warning:true,cache_only:true});
        if(!arr(ability)) return null;
    }
    return call(env,'layer_has',{item_arr:ability,layer_name:layer}) ? Math.max(0,n(call(env,'layer_value',{item_arr:ability,layer_name:layer}))) : 0;
}
/** PHP: ft_zero_vitality_witness_fact (includes/functions/janus/encounter/zero_vitality_witness_triggers.php:130) */
export function ftZeroVitalityWitnessFact(item: P, env: E): number {
    let ft=call(env,'layer_has',{item_arr:item,layer_name:layer}) ? Math.max(0,n(call(env,'layer_value',{item_arr:item,layer_name:layer}))) : 0;
    for(const carrier of values(call(env,'janus_trigger_carriers',{}))) {
        const entries=values(call(env,'layer_entries',{item_arr:item,layer_name:carrier}));
        if(truthy(get(item,carrier)) && arr(get(item,carrier))) entries.push(...values(get(item,carrier)));
        for(const entry of entries) {const one=ftZeroVitalityWitnessEntryFt(entry,item,env);if(one===null) return -1;ft=Math.max(ft,n(one));}
    }
    return ft;
}
